import { handlePageData, selectPageData } from '../utils/pagination';
import { incrementAction, decrementAction } from '../utils/actionState';

export const types = {
  PROJECT_STATIC_FILTERS_REQUEST: 'PROJECT_STATIC_FILTERS_REQUEST',
  PROJECT_STATIC_FILTERS_SUCCESS: 'PROJECT_STATIC_FILTERS_SUCCESS',
  PROJECT_STATIC_FILTERS_FAILURE: 'PROJECT_STATIC_FILTERS_FAILURE',
  PROJECT_CREATE_STATIC_FILTER_REQUEST: 'PROJECT_CREATE_STATIC_FILTER_REQUEST',
  PROJECT_CREATE_STATIC_FILTER_SUCCESS: 'PROJECT_CREATE_STATIC_FILTER_SUCCESS',
  PROJECT_CREATE_STATIC_FILTER_FAILURE: 'PROJECT_CREATE_STATIC_FILTER_FAILURE',
  PROJECT_DELETE_STATIC_FILTER_REQUEST: 'PROJECT_DELETE_STATIC_FILTER_REQUEST',
  PROJECT_DELETE_STATIC_FILTER_SUCCESS: 'PROJECT_DELETE_STATIC_FILTER_SUCCESS',
  PROJECT_DELETE_STATIC_FILTER_FAILURE: 'PROJECT_DELETE_STATIC_FILTER_FAILURE',
  PROJECT_PULL_REQUEST_AUTHORS_REQUEST: 'PROJECT_PULL_REQUEST_AUTHORS_REQUEST',
  PROJECT_PULL_REQUEST_AUTHORS_SUCCESS: 'PROJECT_PULL_REQUEST_AUTHORS_SUCCESS',
  PROJECT_PULL_REQUEST_AUTHORS_FAILURE: 'PROJECT_PULL_REQUEST_AUTHORS_FAILURE',
};

export const initialState = {
  error: null,
  staticFilters: {},
  pullRequestAuthors: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PROJECT_STATIC_FILTERS_REQUEST: {
      return {
        ...state,
        staticFilters: {
          ...state.staticFilters,
          isLoading: true,
          error: null,
        },
      };
    }
    case types.PROJECT_STATIC_FILTERS_SUCCESS: {
      const { projectUUID, data, url } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          isLoading: false,
          [projectUUID]: handlePageData(projectStatic, url, data),
          error: null,
        },
      };
    }
    case types.PROJECT_STATIC_FILTERS_FAILURE: {
      return {
        ...state,
        staticFilters: {
          ...state.staticFilters,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case types.PROJECT_CREATE_STATIC_FILTER_REQUEST: {
      const { projectUUID } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          [projectUUID]: {
            ...projectStatic,
            create: incrementAction(projectStatic && projectStatic.create),
          },
        },
      };
    }
    case types.PROJECT_CREATE_STATIC_FILTER_SUCCESS: {
      const { projectUUID, filterUUID } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          [projectUUID]: {
            ...projectStatic,
            lastCreatedFilterUUID: filterUUID,
            create: decrementAction(projectStatic && projectStatic.create),
          },
        },
      };
    }
    case types.PROJECT_CREATE_STATIC_FILTER_FAILURE: {
      const { projectUUID, error } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          [projectUUID]: {
            ...projectStatic,
            create: decrementAction(
              projectStatic && projectStatic.create,
              error
            ),
          },
        },
      };
    }

    case types.PROJECT_DELETE_STATIC_FILTER_REQUEST: {
      const { projectUUID } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          [projectUUID]: {
            ...projectStatic,
            delete: incrementAction(projectStatic && projectStatic.delete),
          },
        },
      };
    }
    case types.PROJECT_DELETE_STATIC_FILTER_SUCCESS: {
      const { projectUUID } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          [projectUUID]: {
            ...projectStatic,
            delete: decrementAction(projectStatic && projectStatic.delete),
          },
        },
      };
    }
    case types.PROJECT_DELETE_STATIC_FILTER_FAILURE: {
      const { projectUUID, error } = action;
      const staticFilters = state.staticFilters || {};
      const projectStatic = (staticFilters && staticFilters[projectUUID]) || {};
      return {
        ...state,
        staticFilters: {
          ...staticFilters,
          [projectUUID]: {
            ...projectStatic,
            delete: decrementAction(
              projectStatic && projectStatic.delete,
              error
            ),
          },
        },
      };
    }
    case types.PROJECT_PULL_REQUEST_AUTHORS_REQUEST: {
      return {
        ...state,
        pullRequestAuthors: {
          ...state.pullRequestAuthors,
          isLoading: true,
          error: null,
        },
      };
    }
    case types.PROJECT_PULL_REQUEST_AUTHORS_SUCCESS: {
      const { projectUUID, data } = action;
      return {
        ...state,
        pullRequestAuthors: {
          ...state.pullRequestAuthors,
          [projectUUID]: data,
          isLoading: false,
          error: null,
        },
      };
    }
    case types.PROJECT_PULL_REQUEST_AUTHORS_FAILURE: {
      const { projectUUID, error } = action;
      return {
        ...state,
        pullRequestAuthors: {
          ...state.pullRequestAuthors,
          [projectUUID]: {
            ...state.pullRequestAuthors[projectUUID],
            isLoading: false,
            error,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};

export const actions = {
  fetchProjectStaticFilters: (projectUUID, page) => ({
    type: types.PROJECT_STATIC_FILTERS_REQUEST,
    projectUUID,
    page,
  }),
  createProjectStaticFilter: (
    projectUUID,
    engine,
    issueName,
    severity,
    displayName
  ) => ({
    type: types.PROJECT_CREATE_STATIC_FILTER_REQUEST,
    projectUUID,
    engine,
    severity,
    issueName,
    displayName,
  }),
  deleteProjectStaticFilter: (projectUUID, filterUUID) => ({
    type: types.PROJECT_DELETE_STATIC_FILTER_REQUEST,
    projectUUID,
    filterUUID,
  }),
  fetchProjectPullRequestAuthors: (projectUUID, inputValue) => ({
    type: types.PROJECT_PULL_REQUEST_AUTHORS_REQUEST,
    projectUUID,
    inputValue,
  }),
};

export const selectors = {
  projectStaticFilters: (state, projectUUID) => {
    const staticFilters = state.projectData.staticFilters || {};
    const filtersByProject =
      (staticFilters && staticFilters[projectUUID]) || {};
    const filterData = selectPageData(filtersByProject);
    return {
      ...filterData,
      error: staticFilters.error,
    };
  },
  projectStaticFilterActions: (state, projectUUID) => {
    const staticFilters = state.projectData.staticFilters || {};
    const filtersByProject =
      (staticFilters && staticFilters[projectUUID]) || {};
    return {
      create: filtersByProject.create,
      delete: filtersByProject.delete,
    };
  },
  projectLastCreatedFilter: (state, projectUUID) => {
    const staticFilters = state.projectData.staticFilters || {};
    const staticFiltersByProject =
      staticFilters && staticFilters[projectUUID]
        ? staticFilters[projectUUID]
        : {};
    return staticFiltersByProject.lastCreatedFilterUUID;
  },
  pullRequestAuthors: (state, projectUUID) =>
    state.projectData.pullRequestAuthors[projectUUID],
};
